import { type HttpErrorResponse } from '@angular/common/http';
import { type DeepPartial } from '@core';
import { type ChildClient } from '@models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ClientManagementActions = createActionGroup({
  events: {
    'Add Child Client': props<{ newUserData: DeepPartial<ChildClient>; }>(),
    'Add Child Client Success': props<{ newClient: ChildClient; }>(),
    'Client Id Changed': props<{ clientId: string; }>(),
    'Client Management Error': props<{ error: HttpErrorResponse; }>(),
    'Load Child Clients': emptyProps(),
    'Load Child Clients Success': props<{ clientList: ChildClient[]; }>(),
    'Update Child Client': props<{ clientClientId: string; clientData: Partial<ChildClient>; }>(),
    'Update Child Client Success': props<{ childClient: ChildClient; }>(),
    'Update Client Require Totp': props<{ clientClientId: string; requireTotp: boolean; }>(),
    'Update Client Require Totp Success': props<{ childClient: ChildClient; }>(),
  },
  source: 'Client Management',
});
